import { useAuth } from "oidc-react";
import { getCurrentUser } from "../services";
import isEmpty from "lodash/isEmpty";
import { setupBaseQuery } from "./reducerService";
import { createApi } from "@reduxjs/toolkit/query/react";

export const userApi = createApi({
    reducerPath: 'userApi',
    baseQuery: setupBaseQuery(process.env.REACT_APP_GENERAL_SETTINGS),
    tagTypes: ['Phone', 'History'],
    refetchOnMountOrArgChange: true,
    endpoints: (builder) => ({
        getUserData: builder.query({
            query: () => `/users/me`,
            providesTags: ['Phone'],
        }),
    }),
});
export const useGetUserDataQuery = () => {
    const authState = useAuth();
    const currentUser = getCurrentUser();
    return userApi.useGetUserDataQuery({}, { skip: authState.isLoading || isEmpty(currentUser.access_token) });
};
